import { FC } from "react";
import { Spacer } from "shared/layout";
import {
  DrivingPermits,
  Passports,
  SocialSecurityForms,
  TravelVisas,
  Vehicles,
} from "./containers";

export const EditDocumentsPage: FC = () => {
  return (
    <Spacer size="m">
      <Passports />
      <TravelVisas />
      <SocialSecurityForms />
      <DrivingPermits />
      <Vehicles />
    </Spacer>
  );
};
